import axios from "axios"

export default function checkResendVerificationEmailResendTimeLeft({ userId }) {
    return new Promise((resolve, reject) => {
        axios.post("account/public/api/v1/check-resend-email-resend-time-left", { user_id: userId })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}